import { render, staticRenderFns } from "./DiscardedReport.vue?vue&type=template&id=0cdb2f54&"
import script from "./DiscardedReport.vue?vue&type=script&lang=js&"
export * from "./DiscardedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports